export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11462.211add2d.jpg";